import { render, staticRenderFns } from "./PanelLayout.vue?vue&type=template&id=6b69dd01&scoped=true"
import script from "./PanelLayout.vue?vue&type=script&lang=js"
export * from "./PanelLayout.vue?vue&type=script&lang=js"
import style0 from "./PanelLayout.vue?vue&type=style&index=0&id=6b69dd01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b69dd01",
  null
  
)

export default component.exports